import React from 'react';
import TextField from 'material-ui/TextField';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';
import NumberFormat from 'react-number-format';
import AutoComplete from 'material-ui/AutoComplete';

import {
    subeventoService,
    tipoApresentacaoService,
    Utils,
} from '../../services';

import PrincipalMaster from '../master/Principal';

class TipoApresentacao extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            subeventoSelecionado: this.props.match.params.subevento,
            nomeSubeventoSelecionado: '',
            dsSubeventos: [],
            aprovado: '',
            modalidade: '',
            menornota: '',
            maiornota: '',
            isPosting: false,
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        this._csrf = (await tipoApresentacaoService.tipoApresentacaoForm()).token;
        const codigoTipoApresentacao = this.props.match.params.codigo;
        if (codigoTipoApresentacao) {
            try {
                const tipoApresentacao = await tipoApresentacaoService.getTipoApresentacao(codigoTipoApresentacao);
                this.setState({
                    editing: true,
                    subeventoSelecionado: this.props.match.params.subevento,
                    nomeSubeventoSelecionado: tipoApresentacao.NOMESUBEVENTO,
                    aprovado: tipoApresentacao.APROVADO,
                    modalidade: tipoApresentacao.MODALIDADE,
                    menorNota: tipoApresentacao.MENORNOTA,
                    maiorNota: tipoApresentacao.MAIORNOTA,
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        } else {
            const subevento = await subeventoService.getSubevento(this.props.match.params.subevento);
            this.setState({ nomeSubeventoSelecionado: subevento.NOME });
        }
        Utils.showLoading(false);
    }

    async onGetSubeventos(value) {
        const subeventos = await subeventoService.getSubeventoPeloNome(value);
        this.setState({ dsSubeventos: subeventos, nomeSubeventoSelecionado: value });
    }

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            subeventoSelecionado,
            aprovado,
            modalidade,
            menorNota,
            maiorNota,
            isPosting,
        } = this.state;

        this.props.history.goBack();

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await tipoApresentacaoService.update({ codigo: +this.props.match.params.codigo, subevento : subeventoSelecionado, aprovado, modalidade, menorNota, maiorNota, _csrf: this._csrf });
            } else {
                response = await tipoApresentacaoService.save({ subevento : subeventoSelecionado, aprovado, modalidade, menorNota, maiorNota, _csrf: this._csrf });
            }
            Utils.showToast(response.message);
            this.props.history.goBack();
        } catch (e) {
            this.setState({ isPosting: false });
            Utils.showToast(e.message);
        }
    }

    render() {
        const {
            aprovado,
            modalidade,
            menorNota,
            maiorNota,
            dsSubeventos,
            nomeSubeventoSelecionado,
            subeventoSelecionado,
            isPosting,
        } = this.state;

        return (
            <PrincipalMaster title="Tipo de Apresentação" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                        <AutoComplete
                                dataSource={dsSubeventos}
                                dataSourceConfig={{ text: 'NOME', value: 'CODIGO' }}
                                onUpdateInput={value => this.onGetSubeventos(value)}
                                onNewRequest={subevento => this.setState({ subeventoSelecionado: subevento.CODIGO })}
                                value={subeventoSelecionado}
                                filter={AutoComplete.noFilter}
                                floatingLabelText="Subevento"
                                openOnFocus={true}
                                fullWidth={true}
                                searchText={nomeSubeventoSelecionado}
                            />
                            <br />
                            <TextField
                                floatingLabelText="Aprovado"
                                value={aprovado}
                                onChange={e => this.setState({ aprovado: e.target.value })}
                                errorText={aprovado ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                required={true}
                            />
                            <br />
                            <TextField
                                floatingLabelText="Modalidade"
                                value={modalidade}
                                onChange={e => this.setState({ modalidade: e.target.value })}
                                errorText={modalidade ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                required={true}
                            />
                            <br />
                            <NumberFormat
                                customInput={TextField}
                                required={true}
                                fullWidth={true}
                                value={menorNota}
                                errorText={menorNota ? "" : "Campo obrigatório"}
                                floatingLabelText="Menor Nota"
                                onChange={e => this.setState({ menorNota: e.target.value })}
                            />
                            <br />
                            <NumberFormat
                                customInput={TextField}
                                required={true}
                                fullWidth={true}
                                value={maiorNota}
                                errorText={maiorNota ? "" : "Campo obrigatório"}
                                floatingLabelText="Maior Nota"
                                onChange={e => this.setState({ maiorNota: e.target.value })}
                            />

                        </div>
                        <div className="fab-buttons">
                            <FloatingActionButton type="submit" disabled={isPosting} style={{ marginRight: 8 }}>
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.goBack()}>
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

export default TipoApresentacao;